// extracted by mini-css-extract-plugin
export var legendIndicator = "_f1-1";
export var legendRight = "_f1-0";